// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Rana backend API
 * The API service for Rana.
 *
 * The version of the OpenAPI document: v1-alpha
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { Site } from "./Site";
import { SiteFromJSON, SiteFromJSONTyped, SiteToJSON, SiteToJSONTyped } from "./Site";
import type { OptionsShort } from "./OptionsShort";
import {
  OptionsShortFromJSON,
  OptionsShortFromJSONTyped,
  OptionsShortToJSON,
  OptionsShortToJSONTyped,
} from "./OptionsShort";

/**
 *
 * @export
 * @interface CatalogHarvesterShort
 */
export interface CatalogHarvesterShort {
  /**
   *
   */
  id: number;
  /**
   *
   */
  type: string;
  /**
   *
   */
  site: Site;
  /**
   *
   */
  options: OptionsShort;
}

/**
 * Check if a given object implements the CatalogHarvesterShort interface.
 */
export function instanceOfCatalogHarvesterShort(value: object): value is CatalogHarvesterShort {
  if (!("id" in value) || value["id"] === undefined) return false;
  if (!("type" in value) || value["type"] === undefined) return false;
  if (!("site" in value) || value["site"] === undefined) return false;
  if (!("options" in value) || value["options"] === undefined) return false;
  return true;
}

export function CatalogHarvesterShortFromJSON(json: any): CatalogHarvesterShort {
  return CatalogHarvesterShortFromJSONTyped(json, false);
}

export function CatalogHarvesterShortFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): CatalogHarvesterShort {
  if (json == null) {
    return json;
  }
  return {
    id: json["id"],
    type: json["type"],
    site: SiteFromJSON(json["site"]),
    options: OptionsShortFromJSON(json["options"]),
  };
}

export function CatalogHarvesterShortToJSON(json: any): CatalogHarvesterShort {
  return CatalogHarvesterShortToJSONTyped(json, false);
}

export function CatalogHarvesterShortToJSONTyped(
  value?: CatalogHarvesterShort | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    id: value["id"],
    type: value["type"],
    site: SiteToJSON(value["site"]),
    options: OptionsShortToJSON(value["options"]),
  };
}
